// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CategoryCard_wrapper__32kcD","title":"CategoryCard_title__2uO7x","items":"CategoryCard_items__21JgW","item":"CategoryCard_item__1BGeF"};